import { render, staticRenderFns } from "./OrdersBtn.vue?vue&type=template&id=7f3bbec2&"
import script from "./OrdersBtn.vue?vue&type=script&lang=js&"
export * from "./OrdersBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports